export default {
      id: "ic_close_delete_light_green-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_close_delete_light_green-usage",
      toString: function () {
        return this.url;
      }
    }